import { useEffect, useState } from 'react';
import { Col, Progress, Row } from 'antd';

import styles from './dashboard.module.scss';
import Icon from 'utils/icon';
import avatar from 'assets/images/avatar.png';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import TransactionComponent from 'modules/dashboard/components/transaction/transaction';
import DashboardItemComponent from 'modules/dashboard/components/dashboardItem/dashboardItem';
import DashboardListComponent from 'modules/dashboard/components/dashboardList/dashboardList';

function DashboardPage() {
	const [isLoading, setIsLoading] = useState(true);
	const [heros] = useState(Array.from(Array(30).keys()));

	const transactionData = [
		{
			name: 'Apr 04',
			uv: 300,
		},
		{
			name: 'Apr 06',
			uv: 350,
		},
		{
			name: 'Apr 08',
			uv: 260,
		},
		{
			name: 'Apr 10',
			uv: 480,
		},
		{
			name: 'Apr 12',
			uv: 300,
		},
		{
			name: 'Apr 14',
			uv: 200,
		},
	];

	const companyList = [
		{
			title: 'Google',
			column1: 1256,
			column1Change: -935,
			column2: 23.6,
			column2Change: -9.35,
		},
		{
			title: 'Facebook',
			column1: 1256,
			column1Change: 935,
			column2: 23.6,
			column2Change: 9.35,
		},
		{
			title: 'Google',
			column1: 1256,
			column1Change: -935,
			column2: 23.6,
			column2Change: -9.35,
		},
		{
			title: 'Facebook',
			column1: 1256,
			column1Change: 935,
			column2: 23.6,
			column2Change: 9.35,
		},
	];

	const investorsList = [
		{
			title: 'Abanob #1234',
			column1: 1256,
			column1Change: -935,
			column2: 2.63,
			column2Change: -1.35,
		},
		{
			title: 'Abanob #1234',
			column1: 76,
			column1Change: 24,
			column2: 7.63,
			column2Change: 8.73,
		},
		{
			title: 'Abanob #1234',
			column1: 1256,
			column1Change: -935,
			column2: 2.63,
			column2Change: -1.35,
		},
		{
			title: 'Abanob #1234',
			column1: 76,
			column1Change: 24,
			column2: 7.63,
			column2Change: 8.73,
		},
	];

	useEffect(() => {
		setTimeout(() => {
			setIsLoading(false);
		}, 1000);
	}, []);

	return (
		<>
			<div className="pageHeader">
				<h3>Dashboard</h3>
				{/* <p>The most important info highlights</p> */}
			</div>

			{isLoading ? (
				<LoadingComponent />
			) : (
				<>
					<div className={styles.statistics}>
						<Row gutter={[20, 20]} className="mb-4">
							<Col span={12} sm={12} lg={6}>
								<DashboardItemComponent
									mainValue={69700}
									description="Total Online Sales"
									percentageValue={2.2}
									state="increase"
									index={1}
								/>
							</Col>

							<Col span={12} sm={12} lg={6}>
								<DashboardItemComponent
									mainValue={29420}
									description="Total Online Visitors"
									percentageValue={2.6}
									state="increase"
									index={2}
								/>
							</Col>

							<Col span={12} sm={12} lg={6}>
								<DashboardItemComponent
									mainValue={29420}
									description="Total Online Visitors"
									percentageValue={2.6}
									state="increase"
									index={3}
								/>
							</Col>

							<Col span={12} sm={12} lg={6}>
								<DashboardItemComponent
									mainValue={29420}
									description="Total Online Visitors"
									percentageValue={2.6}
									state="increase"
									index={4}
								/>
							</Col>

							<Col span={24} lg={12}>
								<div className={`p-0 ${styles.statistics_item}`}>
									<div>
										<h2>
											29,420
											<span className="status danger">
												<Icon name="downArrow" width={10} height={10} />
												2.2%
											</span>
										</h2>
										<p>Orders This Month</p>

										<div className={styles.progressDetails}>
											<span>1,048 to Goal</span>
											<span>62%</span>
										</div>
										<Progress percent={60} showInfo={false} strokeColor="#50CD89" />
									</div>
								</div>
							</Col>

							<Col span={24} lg={12}>
								<div className={`p-0 ${styles.statistics_item}`}>
									<div>
										<h2>6.3k</h2>
										<p>New Users This Month</p>

										<div className={styles.heros}>
											<h6>Today’s Heroes</h6>
											<div>
												{heros.map((hero, i) => i < 5 && <img src={avatar} key={i} />)}
												{heros.length - 6 > 0 && <div>+{heros.length - 6}</div>}
											</div>
										</div>
									</div>
								</div>
							</Col>

							<Col span={24} lg={12}>
								<TransactionComponent data={transactionData} />
							</Col>

							<Col span={24} lg={12}>
								<TransactionComponent data={transactionData} />
							</Col>

							<Col span={24} lg={12}>
								<DashboardListComponent
									title="Top Companies"
									subTitle="Top List"
									tableHeader={['Company', 'Total shares', 'Conversation rate']}
									data={companyList}
								/>
							</Col>

							<Col span={24} lg={12}>
								<DashboardListComponent
									title="Top investors"
									subTitle="Counted in Shares"
									tableHeader={['Investor Name', 'Total shares', 'Total in M SAR']}
									data={investorsList}
								/>
							</Col>
						</Row>
					</div>
				</>
			)}
		</>
	);
}

export default DashboardPage;
